import { MerchantUserUpdatePayload } from "@/models/club";
import { useMutation } from "@tanstack/react-query";
import merchantUserService from "..";

function useUpdateMerchantUser() {
  return useMutation({
    mutationFn: (command: MerchantUserUpdatePayload) => {
      return merchantUserService.updateMerchantUser(command);
    },
  });
}

export default useUpdateMerchantUser;
